<!--
  vim: tabstop=2:softtabstop=2:shiftwidth=2:expandtab:
-->
<template>
  <div class="bmi">
    <h1 class="title">Body Mass Index</h1>
    <div class="field">
      <label class="label">Height [cm]</label>
      <div class="control">
        <input class="input" type="number" v-model.number="height">
      </div>
    </div>
    <div class="field">
      <label class="label">Weight [kg]</label>
      <div class="control">
        <input class="input" type="number" v-model.number="weight">
      </div>
    </div>
    <h1 class="title" v-bind:class="{'normal':weightIsNormal(),'warning':weightIsWarning(),'error':weightIsError()}">{{ bmi }}</h1>
    <h5 class="title is-5">BMI Prime is {{ prime }}</h5>
    <h5 class="title is-5">{{ category }}</h5>
  </div>
</template>

<script>
export default {
  name: 'bmi',
  data () {
    return {
      weight: 0,
      height: 0,
      bmiCategories: Object.freeze({
        VERY_SEVERELY_UNDERWEIGHT: 'Very severely underweight',
        SEVERELY_UNDERWEIGHT: 'Severely underweight',
        UNDERWEIGHT: 'Underweight',
        NORMAL: 'Normal (healthy weight)',
        OVERWEIGHT: 'Overweight',
        OBESE_CLASS_I: 'Obese Class I (Moderately obese)',
        OBESE_CLASS_II: 'Obese Class II (Severely obese)',
        OBESE_CLASS_III: 'Obese Class III (Very severely obese)'
      })
    }
  },
  computed: {
    bmi () {
      try {
        localStorage.weight = this.weight
        localStorage.height = this.height
      } catch (e) {Function.prototype}
      return (this.weight / ((this.height / 100) * (this.height / 100))).toFixed(2)
    },
    prime () {
      return (this.bmi / 25).toFixed(2)
    },
    category () {
      return String(this.bmiCategory)
    },
    bmiCategory () {
      if (this.bmi < 15) {
        return this.bmiCategories.VERY_SEVERELY_UNDERWEIGHT
      } else if (this.bmi >= 15 && this.bmi < 16) {
        return this.bmiCategories.SEVERELY_UNDERWEIGHT
      } else if (this.bmi >= 16 && this.bmi < 18.5) {
        return this.bmiCategories.UNDERWEIGHT
      } else if (this.bmi >= 18.5 && this.bmi < 25) {
        return this.bmiCategories.NORMAL
      } else if (this.bmi >= 25 && this.bmi < 30) {
        return this.bmiCategories.OVERWEIGHT
      } else if (this.bmi >= 30 && this.bmi < 35) {
        return this.bmiCategories.OBESE_CLASS_I
      } else if (this.bmi >= 35 && this.bmi < 40) {
        return this.bmiCategories.OBESE_CLASS_II
      } else {
        return this.bmiCategories.OBESE_CLASS_III
      }
    }
  },
  created () {
    try {
      this.weight = localStorage.weight
      this.height = localStorage.height
    } catch (e) {Function.prototype}
    if (this.weight === undefined) {
      this.weight = 80
    }
    if (this.height === undefined) {
      this.height = 180
    }
  },
  methods: {
    weightIsNormal () {
      if (this.bmiCategory === this.bmiCategories.NORMAL) {
        return true
      } else {
        return false
      }
    },
    weightIsWarning () {
      if (this.bmiCategory === this.bmiCategories.OVERWEIGHT ||
          this.bmiCategory === this.bmiCategories.UNDERWEIGHT) {
        return true
      } else {
        return false
      }
    },
    weightIsError () {
      if (this.bmiCategory === this.bmiCategories.SEVERELY_UNDERWEIGHT ||
          this.bmiCategory === this.bmiCategories.VERY_SEVERELY_UNDERWEIGHT ||
          this.bmiCategory === this.bmiCategories.OBESE_CLASS_I ||
          this.bmiCategory === this.bmiCategories.OBESE_CLASS_II ||
          this.bmiCategory === this.bmiCategories.OBESE_CLASS_III
      ) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
.bmi {
  margin: 0 auto;
  text-align: left;
}
.bmi .title {
  padding-top: 8px;
  text-align: center;
}
.bmi .normal {
  color: #23d160;
}
.bmi .warning {
  color:#ffdd57; 
}
.bmi .error {
  color: #ff3860;
}

</style>
